import styled from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem } from "styles/utils";


export const ModulesPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled(TablePageContent)`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;

export const ThemeCountCell = styled.td`
  text-align: end;
`;